var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"loading":_vm.loading,"value":_vm.selected,"placeholder":_vm.placeholderI18n,"disabled":_vm.disabled},on:{"change":_vm.update}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.name,attrs:{"label":item.name,"value":item.id}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d50e1ff6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dropdown.vue
// module id = null
// module chunks = 